import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import AdminDashboard from './AdminDashboard'; // Import your new dashboard grid
import '../styles/AdminPage.css';

function AdminPage() {
  const location = useLocation();
  // Show the dashboard grid at /admin root only
  const atRootAdmin = location.pathname === "/admin";

  return (
    <div className="admin-container">
      {atRootAdmin ? (
        <AdminDashboard />
      ) : (
        <Outlet />
      )}
    </div>
  );
}

export default AdminPage;